export default {
    'desktop': require( './question-manager' ),
    'mobile': require( './question-manager-mobile' ),
}
